<template>
    <div class="sort-toggler">
        <input
            class=visually-hidden
            :name="name"
            type="checkbox"
            id="sortToggler"
            v-model="value"
            @change="toggleHandler" />
        <label for="sortToggler">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_1098_12055" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect y="24" width="24" height="24" transform="rotate(-90 0 24)" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_1098_12055)">
                    <path d="M20 17L15 22L10 17L11.425 15.6L14 18.175V11H16V18.175L18.575 15.6L20 17ZM14 7L12.575 8.4L10 5.825V13H8L8 5.825L5.425 8.4L4 7L9 2L14 7Z" fill="#252628"/>
                </g>
            </svg>
            <span v-html="text"></span>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'SortToggler',
        props: {
            onloadValue: {
                type: String,
                default: 'price_asc'
            }
        },
        data() {
            return {
                text: 'По возрастанию цены',
                value: false,
                name: 'sort',
                SORTS: ['price_desc', 'price_asc'],
            }
        },
        methods: {
            toggleHandler() {
                if (this.value) {
                    this.text = 'По убыванию цены'
                } else {
                    this.text = 'По возрастанию цены'
                }

                const sort = this.value ? this.SORTS[0] : this.SORTS[1]
                this.$emit('sortChanged', this.name, sort)
            }
        },
        created() {
            if (this.onloadValue === 'price_asc') {
                this.value = false
                this.text = 'По возрастанию цены'
            }

            if (this.onloadValue === 'price_desc') {
                this.value = true
                this.text = 'По убыванию цены'
            }
        }
    }
</script>